<template>
  <div class="wary_list" id="clip_num">
    <van-pull-refresh v-model="isLoading_qj" @refresh="onRefresh">
      <van-sticky>
        <van-dropdown-menu class="list_menu">
          <van-dropdown-item :title="parameterType.time.info" ref="item_time" title-class="list_item" @close="closeItem({type:'item_time'})">
            <ul class="timeUl"> 
              <li :class="parameterType.time.val == 'zdy' ? 'hover':''" @click="showZdytime()">自定义</li>
            </ul>
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-sticky>
      <!-- 内容 -->
      <van-list 
      v-model="loading"
      :finished="finished"
      :finished-text="finished_text"
      @load="getListVanList"
      >
        <div class="pubWary clearfix" v-for="(item,i) of listData" :key="i" @click.stop="judgmentDetail(item)">
          <div class="newTitle"><a v-html='item.title'></a></div>
          <!--摘要-->
          <div class="abstract">
            <p v-html="item._introduce"></p>
          </div>
          <div class="flex newInfo">
            <div class="flex_1 infos">
              <span>{{ item._createTime }}</span>
              <span>{{ item.siteName }}</span></div>
          </div>
        </div> 
      </van-list>
      <!-- 内容end -->
      <!--暂无数据-->
      <div class="nodata" v-show="finished && listData.length == 0">
        <p></p>
        <p>暂无数据</p>
      </div>
    </van-pull-refresh>
    <!--自定义时间-->
    <van-popup
      v-model="timePopup"
      position="bottom"
    >
      <!--开始时间-->
      <van-datetime-picker
        v-model="bTime"
        type="datetime"
        show-toolbar
        title="开始时间"
        confirm-button-text=" "
        cancel-button-text=" "
        :formatter="formatter"
        :visible-item-count = 3
        :max-date="maxDate"
      />
      <!--结束时间-->
      <van-datetime-picker
        v-model="eTime"
        type="datetime"
        title="结束时间"
        :visible-item-count = 3
        confirm-button-text=" "
        cancel-button-text=" "
        :formatter="formatter"
        :max-date="maxDate"
      />
      <div class="timeButton" @click.stop="screenList({type:'zdytime',val:'',info:''})">完成</div>
    </van-popup>
  </div>
</template>

<script>
let moment = require("moment");
import {DatetimePicker,Popup,DropdownItem,DropdownMenu,Sticky,PullRefresh,Toast,List} from 'vant';
import {getRankList} from '@/api/wechat'
export default {
  name:'rankWarning', 
  components: { 
    "van-dropdown-menu": DropdownMenu,
    "van-dropdown-item": DropdownItem,
    "van-sticky": Sticky,
    "van-pull-refresh": PullRefresh,
    "van-datetime-picker": DatetimePicker,
    "van-list": List,
    "van-popup": Popup,
  },
  data(){
    return {
      finished_text:'',
      finished: false,         //终止加载数据
      isLoading_qj:false,
      maxDate:new Date(),          //最大时间
      bTime:new Date(moment().format('l')),  //开始时间,默认 0时0分
      eTime:new Date(),          //结束时间
      timePopup:false,            //是否显示自定义时间
      parameterType:{          //参数控制
          time:{
            val:'',
            info:"全部时间"
          }    
      },
      listParameter: { 
        pageSize:10,
        pageNum:1,
        bTime: "",              //开始时间
        eTime: "",              //结束时间 
      },
      load:true,
      loading: false,          //暂停加载数据
      listData: []
    }
  },
  methods:{
    //跳转详情页
      judgmentDetail(item){
        window.location = item.url
      },
    onRefresh(){ 
       this.getList("screen");
    },
    getListVanList(){ 
      if(!this.finished_text){
        if(this.listData.length){
          this.getList()
        }else{ 
          if(!this.listParameter.bTime && !this.listParameter.eTime){
            this.listParameter.bTime = moment(this.bTime).format("YYYYMMDDHHmmss");
            this.listParameter.eTime = moment(this.eTime).format("YYYYMMDDHHmmss");
            this.listParameter.time = 'zdy';
            this.parameterType.time.val = 'zdy';
      this.parameterType.time.info =  moment(this.bTime).format("MM-DD")+" 至 "+moment(this.eTime).format("MM-DD"); 
          }
          this.getList("screen")
        }
      } 
    },
    closeItem(m){
       /*
        * m.type:
        *    "item_time"            时间层
        *     "screen"                筛选
        *     "item_sourceType"     媒体类型
        * */
       console.log(m)
    },
    //时间过滤
    formatter(type, value){
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      } else if (type === 'hour') {
        return `${value}时`
      } else if (type === 'minute') {
        return `${value}分`
      }
      return value;
    },
    //自定义时间弹层
    showZdytime(){
      this.$refs.item_time.toggle();
      this.timePopup = true;
    },
    //筛选数据
    screenList(){ 
      //媒体类型
      this.listParameter.bTime = moment(this.bTime).format("YYYYMMDDHHmmss");
      this.listParameter.eTime = moment(this.eTime).format("YYYYMMDDHHmmss");
      if(this.listParameter.bTime > this.listParameter.eTime){
        Toast('开始时间不能晚于结束时间！');
        return false;
      }
      this.listParameter.time = 'zdy';
      this.parameterType.time.val = 'zdy';
      this.parameterType.time.info =  moment(this.bTime).format("MM-DD")+" 至 "+moment(this.eTime).format("MM-DD"); 
      this.load = true;
      this.timePopup = false;
      this.getList('screen');
    },
    Info(item){
       // rankStatus 上榜状态：0 初次上榜，1榜单变化，2下榜
      let info = '' 
      const { rankStatus } = item
       if (rankStatus + '' === '0') {
        info = `${item.siteName}平台，#${item.title}#事件位列${item.siteName}热搜榜第${item.rank}名，相关话题热搜值${item.hot}，阅读量${item.readNum}，评论${item.commentNum}`
      } else if (rankStatus + '' === '1') {
        const rankTextTemp = item.hotTrend ? '下降' : '上升'
        const rankTime = item.rankFistTime ? this.getTimeDiff(new Date().getTime(), item.rankFistTime) : ''
        info = `${item.siteName}平台，#${item.title}#事件位列${item.siteName}热搜第${item.rank}名，热搜排名有所${rankTextTemp}。上榜时间${item._rankFistTime}，当前在榜时长${rankTime}`
      } else {
        let rankTime = ''
        if (item.rankLastTime && item.rankFistTime) {
          rankTime = this.getTimeDiff(item.rankLastTime, item.rankFistTime)
        }
        info = `${item.siteName}平台，#${item.title}#事件已被撤下热搜榜，上榜时间:${item._rankFistTime}`
        if (item._rankLastTime) {
          info = info + `，出榜时间:${item._rankLastTime}，在榜总时长${rankTime}`
        }
      }
      return info
    },
    getTimeDiff(rankLastTime, rankFistTime) {
      const date1 = moment(rankLastTime) // 下榜 大
      const date2 = moment(rankFistTime) // 初次 小
      const minute = date1.diff(date2, 'minute')
      const h = Math.floor(minute / 60)
      const m = h ? minute - (60 * h) : minute
      return h + '时' + m + '分钟'
    },
    getList(s){  
      if (this.load) {
        this.load = false;
        if(s == 'screen'){
          //筛选
          this.listParameter.pageNum = 1;
          this.finished = false;
          Toast.loading({
            duration: 0,       // 持续展示 toast
            mask: true,
            message: '加载中...'
          })
        }else{
          this.listParameter.pageNum = parseInt(this.listParameter.pageNum) + 1;
        } 
        getRankList(this.listParameter).then(res=>{
          Toast.clear(); 
          if(res.status == 200){
            let {data} = res
            if(data.code == 200){
              if(data.data.records.length){
                let listArray = data.data.records;
                if(s == 'screen'){
                  this.listData = [];
                } 
                const formatModel = 'YYYY-MM-DD HH:mm'
                listArray.map(item=>{
                  item._title = item.title
                  item._rankFistTime = moment(item.rankFistTime).format(formatModel)
                  item._rankLastTime = item.rankLastTime ? moment(item.rankLastTime).format(formatModel) : ''
                  item._createTime = moment(item.createTime).format(formatModel)
                  item._introduce = this.Info(item)
                  this.listData.push(item)
                })
                //  = listArray  
              }else {
                if(s == 'screen'){
                  this.listData = [];
                }
                this.finished = true;
              }
              if( this.listData.length > 0 && this.finished){
                this.finished_text = "没有更多了"
              }else{
                this.finished_text = ""
              }
              // 加载状态结束
              this.isLoading_qj = false;
              this.loading = false;
              this.load = true; 
            }
          }
        }).catch(err=>{
          Toast.clear();
          this.finished = true;
          // 加载状态结束
          this.loading = false;
          this.isLoading_qj = false;
          this.load = true;
          console.log(err);
        })
      }
    }
  }
}
</script>

<style scoped>
  @import url("./rankWarning.css");
</style>